import { useContext } from 'react';
import { FocusedPatientContext } from '@/contexts/FocusedPatientContext';

export function useFocusedPatient() {
    const context = useContext(FocusedPatientContext);
    if (context === undefined) {
        throw new Error('useFocusedPatient must be used within a FocusedPatientProvider');
    }
    return context;
}
